import * as React from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { EResponseStatus } from '@enums';

import { AppsList, IAppsListProps } from '@components/AppsCatalog/AppsList';
import { ScrollCarousel } from '@components/ui/ScrollCarousel';

import { IAppData } from '@interfaces';

import * as s from './AppsCarousel.scss';

@observer
export class AppsCarousel extends React.PureComponent<IAppsListProps> {

	static defaultProps = {
		apps: [] as IAppData[],
	};

	render() {
		const carouselClass = classNames(
			this.props.className,
			this.props.responseStatus !== EResponseStatus.OK && s.sliderPending,
		);

		return (
			<ScrollCarousel className={carouselClass}>
				<AppsList {...this.props}/>
			</ScrollCarousel>
		);
	}

}
